<template>
    <app-layout title="Paket Pengadaan">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Accordion :multiple="true" :activeIndex="[0, 1, 2, 3, 4]">
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Organisasi Pengadaan</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="paket_pengadaan_id" value="Paket Pengadaan" />
                                                <Dropdown class="w-3/4 md:w-14rem" v-model="form.paket_pengadaan_id" :options="daftar_paket_pengadaan" optionLabel="nama_paket_pengadaan" placeholder="Pilih Paket Pengadaan" required="required" >
                                                    <template #option="slotProps">
                                                        <div class="country-item">
                                                            <div>{{slotProps.option.nama_paket_pengadaan}}</div>
                                                        </div>
                                                    </template>
                                                </Dropdown>
                                                <small v-if="errors.paket_pengadaan_id" id="name-help" class="p-error">Paket Pengadaan Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="pp_id" value="Pejabat Pengadaan" />
                                                <Dropdown
                                                    class="w-3/4"
                                                    v-model="form.pp_id"
                                                    :options="daftar_pp"
                                                    optionLabel="fullname"
                                                    filter
                                                    filterBy="fullname"
                                                    @filter="fetchPP"
                                                    placeholder="Pilih Pejabat Pengadaan"
                                                />
                                                <small v-if="errors.pp_id" id="name-help" class="p-error">PP Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="pphp_id" value="Pejabat Penerima Hasil Pekerjaan" />
                                                <Dropdown
                                                    class="w-3/4"
                                                    v-model="form.pphp_id"
                                                    :options="daftar_pphp"
                                                    optionLabel="fullname"
                                                    filter
                                                    filterBy="fullname"
                                                    @filter="fetchPPHP"
                                                    placeholder="Pilih Pejabat Penerima Hasil Pekerjaan"
                                                />
                                                <small v-if="errors.pphp_id" id="name-help" class="p-error">PPHP Wajib Diisi</small>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Tim Teknis</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="ttpp_id" value="Tim Teknis Perencanaan Pengadaan" />
                                                <Dropdown
                                                    class="w-3/4"
                                                    v-model="form.ttpp_id"
                                                    :options="daftar_ttpp"
                                                    optionLabel="fullname"
                                                    filter
                                                    filterBy="fullname"
                                                    @filter="fetchTTPP"
                                                    placeholder="Pilih Tim Teknis Perencanaan Pengadaan"
                                                />
                                                <small v-if="errors.ttpp_id" id="name-help" class="p-error">Tim Teknis Perencanaan Pengadaan Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="ttpk_id" value="Tim Teknis Pelaksanaan Kontrak" />
                                                <Dropdown
                                                    class="w-3/4"
                                                    v-model="form.ttpk_id"
                                                    :options="daftar_ttpk"
                                                    optionLabel="fullname"
                                                    filter
                                                    filterBy="fullname"
                                                    @filter="fetchTTPK"
                                                    placeholder="Pilih Tim Teknis Pelaksanaan Kontrak"
                                                />
                                                <small v-if="errors.ttpk_id" id="name-help" class="p-error">Tim Teknis Pelaksanaan Kontrak Wajib Diisi</small>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                </Accordion>
                            </div>
                            <div class="flex justify-end mt-5">
                                <button @click="submitForm" class="px-4 py-2 bg-blue-500 text-white rounded">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import axios from 'axios'

import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import JetLabel from "@/Jetstream/Label";
import { Inertia } from '@inertiajs/inertia'
import { useForm } from "@inertiajs/inertia-vue3"
import AppMenuBar from "@/Components/AppMenuBar.vue";
import DeleteDialog from "@/Components/DeleteDialog";
import DropdownWilayah from "@/Components/DropdownWilayah.vue";
import MapInput from "@/Components/MapInput.vue";
import { FilterMatchMode } from "primevue/api";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import AutoComplete from 'primevue/autocomplete';
import Button from "primevue/button";
import Calendar from 'primevue/calendar';
import Card from "primevue/card";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import Dialog from 'primevue/dialog';
import Divider from "primevue/divider";
import Dropdown from 'primevue/dropdown';
import FileUpload from 'primevue/fileupload';
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Menubar from "primevue/menubar";
import MultiSelect from 'primevue/multiselect';
import OverlayPanel from 'primevue/overlaypanel';
import Password from "primevue/password";
import ProgressBar from 'primevue/progressbar';
import RadioButton from 'primevue/radiobutton';
import Textarea from 'primevue/textarea';
import pdfvuer from 'pdfvuer'

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppMenuBar,
        JetLabel,
        DeleteDialog,
        DropdownWilayah,
        MapInput,
        Accordion,
        AccordionTab,
        AutoComplete,
        Button,
        Calendar,
        Card,
        Column,
        DataTable,
        Dialog,
        Divider,
        Dropdown,
        FileUpload,
        InputText,
        InputNumber,
        Menubar,
        MultiSelect,
        OverlayPanel,
        Password,
        ProgressBar,
        RadioButton,
        Textarea,
        pdf: pdfvuer,
    },
    props : {
        errors : Array,
        daftar_paket_pengadaan : Array,
        daftar_pokja : Array,
        daftar_pp : Array,
        daftar_pphp : Array,
        daftar_ttpp : Array,
        daftar_ttpk : Array,
    },
    data : function(){
        return {
            form : {
                name : '',
                permissions : [],
                menus : [],
            },
            ppOptions: [],
            pphpOptions: [],
            ttppOptions: [],
            ttpkOptions: [],
        }
    },
    mounted() {
        this.fetchPP({ value: "" });
        this.fetchPPHP({ value: "" });
        this.fetchTTPP({ value: "" });
        this.fetchTTPK({ value: "" });
    },
    methods : {
        async fetchPP(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_pp",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.ppOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching pp:", error);
            }
        },
        async fetchPPHP(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_pphp",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.pphpOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching pphp:", error);
            }
        },
        async fetchTTPP(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_ttpp",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.ttppOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching ttpp:", error);
            }
        },
        async fetchTTPK(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_ttpk",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.ttpkOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching ttpk:", error);
            }
        },
        submitForm(){
            // alert(this.form)
            Inertia.post('/organisasi_pengadaan/', this.form);
        }
    }
}
</script>
